import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Collapsible, Dropdown, getTestId, isValidObject, StateConfigContext, Typography } from '@airtel/air-design-system';
import { debounce, merge } from 'lodash';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Keyboard, View } from 'react-native';
import { LinkListItemWidget } from '../../../link-list-item-widget';
import { RadioGroupWidget } from '../../../radio-group-widget';
import { UploadFileWidget } from '../../../upload-file-widget';
import { getSkycFormWidgetStyles } from '../../SkycFormWidgetStyles';
import { disabilityInformationConfig, successAvatarConfig } from './DisabilityInformationConfig';
import { getDisabilityInformationStyles } from './DisabilityInformationStyles';
import { getFileSubtitle, getIsDisabledState, getUploadFileErrorText, validateFileInput } from './DisabilityInformationUtils';
export var DisabilityInformation = props => {
  var _a, _b;
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useMemo = useMemo(() => merge({}, disabilityInformationConfig, props), [disabilityInformationConfig, props]),
    id = _useMemo.id,
    testID = _useMemo.testID,
    variant = _useMemo.variant,
    _state = _useMemo.state,
    successStateHeading = _useMemo.successStateHeading,
    stepDetailsProps = _useMemo.stepDetailsProps,
    isExpanded = _useMemo.isExpanded,
    disableToggle = _useMemo.disableToggle,
    radioButtonData = _useMemo.radioButtonData,
    onStepDetailsListItemPressMetaData = _useMemo.onStepDetailsListItemPressMetaData,
    onStepDetailsCtaPressMetaData = _useMemo.onStepDetailsCtaPressMetaData,
    onUserAction = _useMemo.onUserAction,
    uploadsDataProps = _useMemo.uploadsDataProps,
    onValidFormMetaData = _useMemo.onValidFormMetaData,
    onInValidFormMetaData = _useMemo.onInValidFormMetaData,
    autoFormSubmitDebounceDelay = _useMemo.autoFormSubmitDebounceDelay,
    isAutoFormSubmitDebounceAllowed = _useMemo.isAutoFormSubmitDebounceAllowed,
    dropdownsDataProps = _useMemo.dropdownsDataProps,
    style = _useMemo.style;
  var _ref = uploadsDataProps !== null && uploadsDataProps !== void 0 ? uploadsDataProps : {},
    uploadFrontImageDisability = _ref.uploadFrontImageDisability,
    uploadBackImageDisability = _ref.uploadBackImageDisability;
  var skycFormWidgetStyle = getSkycFormWidgetStyles(props);
  var _ref2 = dropdownsDataProps !== null && dropdownsDataProps !== void 0 ? dropdownsDataProps : {},
    disabilityTypesData = _ref2.disabilityTypesData;
  var disabilityInformationStyle = getDisabilityInformationStyles();
  var _useState = useState(isExpanded),
    isExpandedState = _useState[0],
    setIsExpandedState = _useState[1];
  var _useState2 = useState(disabilityTypesData),
    disabilityTypesDataProps = _useState2[0],
    setDisabilityTypesDataProps = _useState2[1];
  var _useState3 = useState(_state),
    stateType = _useState3[0],
    setStateType = _useState3[1];
  var isDisabledState = stateType === 'disabled';
  var isSuccessState = stateType === 'success';
  var _useState4 = useState(''),
    disability = _useState4[0],
    setDisability = _useState4[1];
  var _useState5 = useState({
      front: null,
      back: null
    }),
    uploadedFilesInfo = _useState5[0],
    setUploadedFilesInfo = _useState5[1];
  var _useState6 = useState({
      disability: '',
      dropdownValue: '',
      frontFile: null,
      backFile: null
    }),
    formData = _useState6[0],
    setFormData = _useState6[1];
  var _useState7 = useState({
      front: 'none',
      back: 'none'
    }),
    fileState = _useState7[0],
    setFileState = _useState7[1];
  useEffect(() => {
    setStateType(_state);
    setIsExpandedState(_state === 'none');
  }, [_state]);
  useEffect(() => {
    setDisabilityTypesDataProps(prev => {
      return Object.assign(Object.assign({}, prev), disabilityTypesData);
    });
  }, [JSON.stringify(disabilityTypesData)]);
  useEffect(() => {
    setIsExpandedState(isExpanded);
    if (!isExpanded) Keyboard.dismiss();
  }, [isExpanded]);
  useEffect(() => {
    if ((formData === null || formData === void 0 ? void 0 : formData.disability) !== '') handleValidation(formData);
  }, [formData]);
  useEffect(() => {
    var onErrorMetaDataFront = uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.onErrorMetaData;
    var onErrorMetaDataBack = uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.onErrorMetaData;
    if (fileState.front === 'error') {
      isValidObject(onErrorMetaDataFront) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onErrorMetaDataFront), {
        type: 'front',
        action: 'error',
        value: getUploadFileErrorText(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.front)
      }));
    }
    if (fileState.back === 'error') {
      isValidObject(onErrorMetaDataBack) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onErrorMetaDataBack), {
        type: 'back',
        action: 'error',
        value: getUploadFileErrorText(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.back)
      }));
    }
  }, [fileState]);
  var onRadioSelectionHandler = data => {
    var value = data === null || data === void 0 ? void 0 : data.value;
    setDisability(value);
    if ((value === null || value === void 0 ? void 0 : value.toLowerCase()) === 'no') {
      setUploadedFilesInfo({
        front: null,
        back: null
      });
      setFormData(prev => Object.assign(Object.assign({}, prev), {
        disability: value,
        dropdownValue: '',
        frontFile: null,
        backFile: null
      }));
    } else {
      setFormData(prev => Object.assign(Object.assign({}, prev), {
        disability: value
      }));
    }
  };
  var handleFileUpload = (type, _ref3) => {
    var event = _ref3.event;
    var _a;
    var files = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.files;
    if (files.length > 0) {
      var selectedFile = files === null || files === void 0 ? void 0 : files[0];
      var _ref4 = selectedFile || {},
        name = _ref4.name,
        size = _ref4.size;
      var _validateFileInput = validateFileInput(name, size),
        isSizeValid = _validateFileInput.isSizeValid,
        isTypeValid = _validateFileInput.isTypeValid;
      var isFileValid = isSizeValid && isTypeValid;
      if (!isFileValid) {
        setFileState(prev => Object.assign(Object.assign({}, prev), {
          [type]: 'error'
        }));
      } else {
        var onSelectValidFile = {};
        if (type === 'front') {
          onSelectValidFile = uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.onSelectValidFile;
        } else {
          onSelectValidFile = uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.onSelectValidFile;
        }
        isValidObject(onSelectValidFile) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onSelectValidFile), {
          type,
          action: 'upload',
          file: selectedFile
        }));
      }
      var fileData = {
        fileName: name,
        fileSize: size,
        imgUrl: URL.createObjectURL(files[0]),
        error: !isFileValid ? {
          isSizeValid,
          isTypeValid
        } : null
      };
      setUploadedFilesInfo(prev => {
        var uploadedFile = Object.assign(Object.assign({}, prev), {
          [type]: fileData
        });
        return uploadedFile;
      });
      setFormData(prev => {
        var fileInfo = {
          fileName: name,
          fileSize: size
        };
        return Object.assign(Object.assign({}, prev), {
          [type + 'File']: fileInfo
        });
      });
      var onChangeMetaData = {};
      if (type === 'front') {
        onChangeMetaData = uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.onChangeMetaData;
      } else {
        onChangeMetaData = uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.onChangeMetaData;
      }
      isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onChangeMetaData), {
        type,
        action: 'upload',
        value: name,
        file: selectedFile
      }));
    }
  };
  var handleDeleteFile = type => {
    setUploadedFilesInfo(prev => Object.assign(Object.assign({}, prev), {
      [type]: null
    }));
    setFormData(prev => Object.assign(Object.assign({}, prev), {
      [type + 'File']: null
    }));
    var onChangeMetaData = {};
    if (type === 'front') {
      onChangeMetaData = uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.onChangeMetaData;
    } else {
      onChangeMetaData = uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.onChangeMetaData;
    }
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeMetaData), {
      type,
      action: 'delete'
    }));
  };
  var debouncedUserAction = useCallback(debounce(onUserAction, autoFormSubmitDebounceDelay), []);
  var handleValidation = formData => {
    var disability = formData.disability,
      dropdownValue = formData.dropdownValue,
      frontFile = formData.frontFile,
      backFile = formData.backFile;
    var isValid = (disability === null || disability === void 0 ? void 0 : disability.toLowerCase()) === 'no';
    if ((disability === null || disability === void 0 ? void 0 : disability.toLowerCase()) === 'yes') {
      var _validateFileInput2 = validateFileInput(frontFile === null || frontFile === void 0 ? void 0 : frontFile.fileName, frontFile === null || frontFile === void 0 ? void 0 : frontFile.fileSize),
        isSizeValid = _validateFileInput2.isSizeValid,
        isTypeValid = _validateFileInput2.isTypeValid;
      isValid = isSizeValid && isTypeValid && dropdownValue !== '';
      if ((uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.front) && (uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.back)) {
        var _validateFileInput3 = validateFileInput(backFile === null || backFile === void 0 ? void 0 : backFile.fileName, backFile === null || backFile === void 0 ? void 0 : backFile.fileSize),
          _isSizeValid = _validateFileInput3.isSizeValid,
          _isTypeValid = _validateFileInput3.isTypeValid;
        isValid = isValid && _isSizeValid && _isTypeValid;
      }
    }
    var metaData = isValid ? onValidFormMetaData : onInValidFormMetaData;
    if (!isValidObject(metaData) || !onUserAction) return;
    var userActionPayload = [Object.assign({
      id
    }, metaData), Object.assign({
      props
    }, formData)];
    if (isAutoFormSubmitDebounceAllowed) {
      debouncedUserAction(...userActionPayload);
    } else {
      onUserAction(...userActionPayload);
    }
    return isValid;
  };
  var handleDropdownChange = data => {
    var _a, _b;
    var value = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.value;
    setFormData(prev => {
      return Object.assign(Object.assign({}, prev), {
        dropdownValue: value
      });
    });
    var onChangeMetaData = disabilityTypesDataProps.onChangeMetaData;
    isValidObject(onChangeMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onChangeMetaData), {
      value: (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b.value
    }));
  };
  var handleRetryUpload = type => {
    setFileState(prev => Object.assign(Object.assign({}, prev), {
      [type]: 'none'
    }));
    setUploadedFilesInfo(prev => Object.assign(Object.assign({}, prev), {
      [type]: null
    }));
  };
  var handleChangeButtonPress = () => {
    setIsExpandedState(true);
  };
  return isValidObject(stepDetailsProps) && _jsxs(Collapsible, Object.assign({
    removeOverflow: true,
    childPaddingToken: "SPACING_0",
    theme: theme,
    style: [skycFormWidgetStyle.heading, style],
    titleNoVerticalPadding: true,
    titleNoHorizontalPadding: true,
    isExpanded: isExpandedState,
    showIcon: false,
    disabled: getIsDisabledState(isDisabledState, disableToggle),
    withCard: true,
    titleComponent: _jsx(LinkListItemWidget, Object.assign({}, stepDetailsProps, isSuccessState && !isExpandedState && successStateHeading && {
      heading: successStateHeading
    }, {
      roundedCorners: true,
      theme: theme,
      noHoverEffect: true,
      noPressEffect: true,
      onPress: onStepDetailsListItemPressMetaData,
      onUserAction: onUserAction,
      actionTypeProps: !isExpandedState && !isDisabledState && (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.actionTypeProps),
      actionTypeOnPressMetaData: onStepDetailsCtaPressMetaData,
      actionTypeOnPress: handleChangeButtonPress
    }, isSuccessState && Object.assign({}, successAvatarConfig), isSuccessState && !isExpandedState && {
      subHeading: (disability === null || disability === void 0 ? void 0 : disability.toLowerCase()) === 'yes' ? 'Yes' : 'No'
    }, {
      disabled: getIsDisabledState(isDisabledState, stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.disabled),
      subHeadingNumberOfLines: (stepDetailsProps === null || stepDetailsProps === void 0 ? void 0 : stepDetailsProps.subHeadingNumberOfLines) || 1
    }, getTestId(testID, variant + "_LinkedList")))
  }, getTestId(testID, variant + "_Collapisble"), {
    children: [_jsx(View, Object.assign({
      style: skycFormWidgetStyle.content
    }, {
      children: _jsx(RadioGroupWidget, Object.assign({}, getTestId(testID, variant + "_Radio"), radioButtonData, {
        onUserAction: onUserAction,
        onSelectionHandler: onRadioSelectionHandler,
        checkedRadioId: disability,
        radioButtonStyle: disabilityInformationStyle.radio
      }), "skyc-radio")
    })), disability === 'Yes' && _jsxs(View, Object.assign({
      style: skycFormWidgetStyle.content
    }, {
      children: [_jsx(Dropdown, Object.assign({
        theme: theme,
        style: disabilityInformationStyle.dropdown
      }, disabilityTypesDataProps, {
        onSelectedHandler: value => handleDropdownChange(value),
        position: "below",
        listMaxHeightPercentage: 30
      }, getTestId(testID, variant + "_Dropdown"))), _jsx(Typography, {
        text: "Upload document",
        style: disabilityInformationStyle.label,
        type: "body-single-line-xs"
      }), _jsx(UploadFileWidget, Object.assign({}, uploadFrontImageDisability, {
        style: disabilityInformationStyle.uploadFileWidget,
        hideOnUpload: true,
        uploadedFiles: uploadedFilesInfo.front && [{
          title: 'Front side',
          subTitle: getFileSubtitle(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.front),
          showDeleteIcon: (fileState === null || fileState === void 0 ? void 0 : fileState.front) !== 'error' && !(uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.isUploading) && !(uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.errorText),
          imgUrl: (_a = uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.front) === null || _a === void 0 ? void 0 : _a.imgUrl,
          handleDeletePress: () => handleDeleteFile('front'),
          state: (uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.errorText) ? 'error' : fileState === null || fileState === void 0 ? void 0 : fileState.front,
          hintText: (uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.errorText) || getUploadFileErrorText(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.front),
          handleActionCtaPress: () => handleRetryUpload('front'),
          actionCtaIconName: 'ReloadButtonIcon',
          actionCtaText: ((fileState === null || fileState === void 0 ? void 0 : fileState.front) === 'error' || (uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.errorText)) && !(uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.isUploading) && 'RETRY',
          isLoading: uploadFrontImageDisability === null || uploadFrontImageDisability === void 0 ? void 0 : uploadFrontImageDisability.isUploading
        }],
        onUserAction: (_, data) => handleFileUpload('front', data)
      }, getTestId(testID, variant + "_front_UploadFileWidget"))), _jsx(UploadFileWidget, Object.assign({}, uploadBackImageDisability, {
        hideOnUpload: true,
        uploadedFiles: uploadedFilesInfo.back && [{
          title: 'Back side',
          subTitle: getFileSubtitle(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.back),
          showDeleteIcon: (fileState === null || fileState === void 0 ? void 0 : fileState.back) !== 'error' && !(uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.isUploading) && !(uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.errorText),
          imgUrl: (_b = uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.back) === null || _b === void 0 ? void 0 : _b.imgUrl,
          handleDeletePress: () => handleDeleteFile('back'),
          state: (uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.errorText) ? 'error' : fileState === null || fileState === void 0 ? void 0 : fileState.back,
          hintText: (uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.errorText) || getUploadFileErrorText(uploadedFilesInfo === null || uploadedFilesInfo === void 0 ? void 0 : uploadedFilesInfo.back),
          handleActionCtaPress: () => handleRetryUpload('back'),
          actionCtaIconName: 'ReloadButtonIcon',
          actionCtaText: ((fileState === null || fileState === void 0 ? void 0 : fileState.back) === 'error' || (uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.errorText)) && !(uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.isUploading) && 'RETRY',
          isLoading: uploadBackImageDisability === null || uploadBackImageDisability === void 0 ? void 0 : uploadBackImageDisability.isUploading
        }],
        onUserAction: (_, data) => handleFileUpload('back', data)
      }, getTestId(testID, variant + "_back_UploadFileWidget")))]
    }))]
  }));
};